import * as icons from '@coreui/icons'
export const iconsSet = Object.assign(
  {},
  icons
)
